import { useContext } from "react";

import { CoreWindowId } from "./constants";
import { DispatchContext, DispatchWindows, State, StateContext } from "./reducer";

export function useWindows(): State {
    const context = useContext(StateContext);

    if (context === undefined) {
        throw new Error("useWindows must be used within a WindowsProvider");
    }

    return context;
}

export function useDispatchWindows(): DispatchWindows {
    const context = useContext(DispatchContext);

    if (context === undefined) {
        throw new Error("useDispatchWindows must be used within a WindowsProvider");
    }

    return context;
}

export function useWindow(windowId: CoreWindowId) {
    const windows = useWindows();
    return windows[windowId];
}
